export const FETCH_JOB_AGENCY_REQUEST = 'FETCH_JOB_AGENCY_REQUEST';
export const FETCH_JOB_AGENCY_SUCCESS = 'FETCH_JOB_AGENCY_SUCCESS';
export const FETCH_JOB_AGENCY_FAIL = 'FETCH_JOB_AGENCY_FAIL';

export const CREATE_JOB_AGENCY_REQUEST = 'CREATE_JOB_AGENCY_REQUEST';
export const CREATE_JOB_AGENCY_SUCCESS = 'CREATE_JOB_AGENCY_SUCCESS';
export const CREATE_JOB_AGENCY_FAIL = 'CREATE_JOB_AGENCY_FAIL';

export const UPDATE_JOB_AGENCY_REQUEST = 'UPDATE_JOB_AGENCY_REQUEST';
export const UPDATE_JOB_AGENCY_SUCCESS = 'UPDATE_JOB_AGENCY_SUCCESS';
export const UPDATE_JOB_AGENCY_FAIL = 'UPDATE_JOB_AGENCY_FAIL';
